module.exports = __webpack_public_path__ + "static/img/Campbell.c1a9f2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Campbell.jpg
// module id = Mv6c
// module chunks = 0